export class TagsInputDTO
 {
    key :string
    value :string
  
}
